import { Link } from 'react-router-dom'

import { useI18n } from '../lib/i18n.jsx'
import { Container, EmptyState, Section } from '../ui/index.js'

/**
 * 404 page.
 *
 * Kept inside the public shell, so a visitor who mistyped a URL still has the
 * navigation, the language switch and the footer — a dead-end 404 stripped of
 * chrome makes people leave the site rather than find the page they meant.
 *
 * No search box and no list of "popular pages": the header already carries the
 * seven places this site has.
 *
 * 404 页。
 *
 * 保留在公开外壳内，让敲错网址的访客依然有导航、语言切换和页脚——一个剥掉框架的
 * 死胡同式 404，只会让人离开站点，而不是找到他本来想去的页面。
 *
 * 不放搜索框，也不列「热门页面」：页头已经列出了本站全部七个去处。
 *
 * @returns {JSX.Element} Page / 页面。
 */
export default function NotFound() {
  const { t } = useI18n()

  return (
    <Section className="notfound-page">
      <Container width="narrow">
        <EmptyState
          className="notfound"
          title={t('error.notFound')}
          body={t('error.notFoundBody')}
          action={
            <Link className="link-button link-button--ghost" to="/">
              {t('nav.home')}
            </Link>
          }
        />
      </Container>
    </Section>
  )
}
